import React from 'react';

export const MessageContext = React.createContext({
  /* eslint-disable */
  showErrorMessage: (message) => console.error(message),
  showSuccessMessage: (message) => console.error(message),
  mutateMessage: (message) => console.error(message),
  /* eslint-enable */
});
export default MessageContext;
